import { FunctionComponent, useState } from 'react';
import { Card, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

// components
import HeirsViewerComponent from './heirsViewer';
import SharesCount from 'components/sharesCount/sharesCount';
import DisabledElement from 'components/disabledElement/disabledElement';

// services

// styles

// models
import { HeirTransfer } from '../models/heir';
import { isRTL } from 'core/services/language';
import PhoneInputComponent from 'components/phoneInput/phoneInput';
import { dateFormat } from 'utils/dateFormat';

interface DeceasedDetailsViewerComponentProps {
	deceasedDetails: HeirTransfer['deceased'];
}

const DeceasedDetailsViewerComponent: FunctionComponent<DeceasedDetailsViewerComponentProps> = ({ deceasedDetails }) => {
	const { t } = useTranslation();

	return (
		<Row gutter={[16, 16]}>
			<Col span={24} md={12}>
				<DisabledElement
					fullWidth
					label={t('COMMON.NAME')}
					value={isRTL() ? deceasedDetails?.shareholder.name : deceasedDetails?.shareholder.name_en ?? deceasedDetails?.shareholder.name}
				/>
			</Col>

			<Col span={24} md={12}>
				<DisabledElement fullWidth label={t('COMMON.NATIONAL_ID')} value={deceasedDetails?.shareholder.national_id} />
			</Col>

			<Col span={24} md={12}>
				<DisabledElement fullWidth label={t('COMMON.DATE_OF_BIRTH')} value={dateFormat(deceasedDetails?.shareholder.date_of_birth, true)} />
			</Col>

			<Col span={24} md={12}>
				<PhoneInputComponent
					disabled
					fullWidth
					userDialCode={deceasedDetails?.shareholder?.phone_country_code}
					userPhoneNumber={deceasedDetails?.shareholder?.phone_number}
				/>
			</Col>

			<Col span={24} md={12}>
				<SharesCount
					fullWidth
					title={t('ACTIONS.COUNT_OF_COMMON_SHARES')}
					total={deceasedDetails?.common_shares_count}
					free={deceasedDetails?.free_common_shares_count}
					suspended={deceasedDetails?.suspended_common_shares_count}
					mortgaged={deceasedDetails?.mortgaged_common_shares_count}
				/>
			</Col>

			{deceasedDetails?.preferred_shares_count && deceasedDetails?.preferred_shares_count > 0 ? (
				<Col span={24} md={12}>
					<SharesCount
						fullWidth
						title={t('ACTIONS.COUNT_OF_PREFERRED_SHARES')}
						total={deceasedDetails?.preferred_shares_count}
						free={deceasedDetails?.free_preferred_shares_count}
						suspended={deceasedDetails?.suspended_preferred_shares_count}
						mortgaged={deceasedDetails?.mortgaged_preferred_shares_count}
					/>
				</Col>
			) : null}
		</Row>
	);
};

export default DeceasedDetailsViewerComponent;
